import { yaNative } from '@weberus/ui/utils/ya-native';

/**
 * 웹은 페이지, 앱은 딥링크로 이동하는 함수
 */
export const navigateTo = (action: { app: string; web: string }) => {
  if (yaNative.isEnabled) {
    yaNative.deepLink({ link: action.app });
  } else {
    location.href = action.web;
  }
};
